import { render, staticRenderFns } from "./SidebarWithoutBackdrop.vue?vue&type=template&id=571b1e47&"
import script from "./SidebarWithoutBackdrop.vue?vue&type=script&lang=js&"
export * from "./SidebarWithoutBackdrop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports